import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { MaterialRequisitionFormResponse } from '@Types/api/form';
import { parseDateTime } from '@Utils/transformDateTime';

interface FieldSourceProps {
  data: MaterialRequisitionFormResponse;
  costCenterTypeDesc: string | undefined;
  costCenterName: string | undefined;
  companyName: string | undefined;
}

const fieldSource = ({
  data,
  costCenterTypeDesc,
  costCenterName,
  companyName,
}: FieldSourceProps): Array<{
  label: string;
  value: string | number | boolean;
}> => {
  const { reqNo, updatedOn, statusId } = data;

  const source = {
    'Company Name': companyName || EMPTY_FIELD_PLACEHOLDER,
    Status: statusId,
    'Request No.': reqNo,
    'Request Type': 'Material',
    'Request Date': parseDateTime(updatedOn),
    'Cost Center Type': costCenterTypeDesc || EMPTY_FIELD_PLACEHOLDER,
    'Cost Center': costCenterName || EMPTY_FIELD_PLACEHOLDER,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
